import homeImage from "@/images/ghs_home.jpg";
import { Logo } from "@/components/lib";

export function Home() {
  return (
    <div className="flex flex-col gap-4 lg:gap-8 text-center text-white">
      <Logo className="w-48 lg:w-64 mx-auto my-5 sm:mt-0 lg:hidden" />

      <div className="relative w-full overflow-hidden shadow-lg pb-4">
        <img
          src={homeImage}
          alt="Grapevine High School"
          className="w-full h-96 lg:h-[85vh] object-cover opacity-20"
        />

        <div
          className="absolute inset-0"
          style={{
            background:
              "linear-gradient(180deg, rgba(7, 16, 27, 0) 18.3%, #07101B 100%)"
          }}
        />

        <div className="absolute bottom-0 top-1/3 -translate-y-1/4 left-1/2 -translate-x-1/2 text-white w-4/5 lg:w-2/3">
          <p
            className="text-2xl md:text-3xl lg:text-5xl xl:text-7xl leading-[calc(1.25_*_theme(fontSize.3xl))] lg:leading-[calc(1.25_*_theme(fontSize.6xl))] xl:leading-[calc(1.25_*_theme(fontSize.7xl))]"
            style={{ fontFamily: '"Black Ops One", cursive' }}
          >
            DEVELOP
            <br /> A <u>COMPLETE</u>
            <br />
            <u>MAN</u> TO <u>INVEST</u>
            <br />
            THEMSELVES INTO A<br />
            <u>COMPLETE</u> PROGRAM
          </p>
          <a
            href="/players"
            className="mt-10 font-bold mx-auto bg-[#CF2027] px-2 py-2 lg:px-6 lg:py-3 lg:text-3xl rounded-full w-full md:w-1/2 flex justify-center hover:bg-[#CF202790] transition-colors"
          >
            MEET OUR PLAYERS
          </a>
        </div>
      </div>
    </div>
  );
}
